export default __webpack_public_path__ + "static/media/zoho_chat.5971b98c.svg";